import { useState } from 'react';
import { Brain } from 'lucide-react';
import { useWaapAiWafCharts, AIWAF_TIME_RANGES, type AiWafTimeRange } from '@/api/waap';
import { useWaapWebsite } from '@/pages/services/waap/waap-context';
import { WaapAnalyticsBoard } from './WaapAnalyticsBoard';

/**
 * Analytics → AI-WAF — NATIVE charts (Superset dashboard 40) rendered through the
 * shared board shell. The wide Threat Details log lands in the full-width lane.
 */
export function AiWafTab() {
  const { selected } = useWaapWebsite();
  const [range, setRange] = useState<AiWafTimeRange>('Last 24 Hours');
  const [domains, setDomains] = useState<string[]>([]);
  const query = useWaapAiWafCharts(selected?.domainId, range, domains);
  return (
    <WaapAnalyticsBoard
      icon={<Brain size={26} />}
      label="AI-WAF"
      ranges={AIWAF_TIME_RANGES}
      range={range}
      onRangeChange={setRange}
      domains={domains}
      onDomainsChange={setDomains}
      query={query}
    />
  );
}
